// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#customRevealBgVideo[data-v-67bf9be0]{position:absolute;top:0;left:50%;transform:translate(-50%);width:100%;height:100%;z-index:0;-o-object-fit:cover;object-fit:cover}", ""]);
// Exports
module.exports = exports;
